import React from "react";
import { Link } from "react-router-dom";
import MarketingNav from "./MarketingNav";
import MarketingFooter from "./MarketingFooter";
import "./MarketingPage.css";

const MarketingPage = () => {
  return (
    <div className="marketing-root">
      <MarketingNav />

      {/* HERO */}
      <section className="hero">
        <div
          className="hero-text"
          style={{ marginTop: -60, position: "relative" }}
        >
          <div className="hero-glow"></div>
          <div className="hero-eyebrow">
            <span></span> Now available
          </div>
          <h1>
            Your life,
            <br />
            <em>logged.</em>
          </h1>
          <p className="hero-sub">
            A micro-journal that captures moments as they happen — no setup, no
            habits to configure.
          </p>
          <div className="hero-actions">
            <Link to="/signup" className="btn btn-primary">
              Get Started Free
            </Link>
            <a href="#how-it-works" className="btn btn-ghost">
              See how it works
            </a>
          </div>
          <p className="hero-note">
            30-day free trial · No credit card required
          </p>
        </div>

        <div
          className="mock-wrapper"
          style={{ marginTop: 60, position: "relative" }}
        >
          <div className="app-mock">
            <div className="mock-search">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#666"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
              Search moments...
            </div>

            <div className="mock-date-label">Today</div>
            <div className="mock-card">
              <div className="mock-card-header">
                <div className="mock-card-meta">
                  <span className="mock-tag">memorloko</span>
                  <span className="mock-ago">2h ago</span>
                </div>
                <span className="mock-time">6:53 PM</span>
              </div>
              <div className="mock-title">started a new project</div>
              <div className="mock-body">Feeling focused today</div>
              <div className="mock-dots">···</div>
            </div>

            <div className="mock-date-label" style={{ marginTop: 12 }}>
              Fri Apr 3
            </div>
            <div className="mock-card">
              <div className="mock-card-header">
                <div className="mock-card-meta">
                  <span className="mock-tag">cooking</span>
                  <span className="mock-ago">15d ago</span>
                </div>
                <span className="mock-time">10:13 AM</span>
              </div>
              <div className="mock-title">started sous viding beef brisket</div>
              <div className="mock-dots">···</div>
            </div>
            <div className="mock-card">
              <div className="mock-card-header">
                <div className="mock-card-meta">
                  <span className="mock-tag">exercise</span>
                  <span className="mock-ago">15d ago</span>
                </div>
                <span className="mock-time">1:37 PM</span>
              </div>
              <div className="mock-title">barbell curls</div>
              <div className="mock-body">
                Warmup
                <br />
                10 × 30lbs – easy
                <br />
                <br />
                Sets
                <br />
                7 × 40lbs – challenging
              </div>
              <div className="mock-dots">···</div>
            </div>
          </div>
          <div className="mock-fab">+</div>
        </div>
      </section>

      <hr className="section-divider" />

      {/* HOW IT WORKS */}
      <section id="how-it-works">
        <div className="section-label">How it works</div>
        <h2>
          Log it. Find it.
          <br />
          Live better.
        </h2>
        <div className="steps">
          <div className="step">
            <div className="step-num">01</div>
            <div className="step-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="#888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
              </svg>
            </div>
            <h3>Track Moments</h3>
            <p>
              Note actions and events as they happen. Add details and photos if
              you like. No templates required.
            </p>
          </div>
          <div className="step">
            <div className="step-num">02</div>
            <div className="step-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="#888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </div>
            <h3>Recall & Review</h3>
            <p>
              Search past moments instantly. View as a daily list or calendar.
              Remember what you've done.
            </p>
          </div>
          <div className="step">
            <div className="step-num">03</div>
            <div className="step-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="#888"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 22V12" />
                <path d="M12 12C12 12 7 10 7 5c0 0 4-1 7 3 3-4 7-3 7-3 0 5-5 7-5 7H12Z" />
              </svg>
            </div>
            <h3>Live Mindfully</h3>
            <p>
              See patterns in how you spend your time. No streaks to maintain —
              just awareness.
            </p>
          </div>
        </div>
      </section>

      <hr className="section-divider" />

      {/* PRICING */}
      <section id="pricing">
        <div className="section-label">Pricing</div>
        <h2>Simple, honest pricing.</h2>

        <div className="pricing-cards">
          <div className="price-card">
            <div className="price-card-name">Core</div>
            <div className="price-amount">$1.99</div>
            <div className="price-period">per month</div>
            <ul className="price-features">
              <li>Unlimited entries</li>
              <li>Export CSV</li>
              <li>Basic data table</li>
              <li>3 photos per entry</li>
            </ul>
          </div>
          <div className="price-card coming-soon">
            <div className="coming-soon-badge">Coming Soon</div>
            <div className="price-card-name">More</div>
            <div className="price-amount">$7.99</div>
            <div className="price-period">per month</div>
            <ul className="price-features">
              <li>Everything in Core</li>
              <li>Advanced data table</li>
              <li>20 photos per entry</li>
              <li>AI Helper</li>
              <li>Voice input</li>
            </ul>
          </div>
        </div>

        <div className="pricing-cta">
          <Link to="/signup" className="btn btn-primary">
            Start your 30-day free trial
          </Link>
          <p>No credit card required.</p>
        </div>
      </section>

      <hr className="section-divider" />

      {/* FAQ */}
      <section id="faq">
        <div className="section-label">FAQ</div>
        <h2>Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <div className="faq-q">What should I track?</div>
            <div className="faq-a">
              Anything you do. Meals, meds, workouts, chores, feelings — if it
              happened, log it.
            </div>
          </div>
          <div className="faq-item">
            <div className="faq-q">Who is this for?</div>
            <div className="faq-a">
              Anyone who wants to remember how they spend their time. Especially
              if you struggle with time-blindness or forgetfulness.
            </div>
          </div>
          <div className="faq-item">
            <div className="faq-q">Do I need a Google account?</div>
            <div className="faq-a">Yes, for now.</div>
          </div>
          <div className="faq-item">
            <div className="faq-q">How is this different from a habit tracker?</div>
            <div className="faq-a">
              You don't decide in advance what to track — just log things as you
              do them. No configuring habits, no streaks to fail.
            </div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
};

export default MarketingPage;
